<i18n
  src="@/locales/views/packing_house/process/exec_steps/show_step.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/process_line_exec_step.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="this.routeName('show_process')"
      :params="{
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
      }"
    ></go-back-link>

    <bread-crumbs
      :labels="[
        module_name,
        packing_house_process.name,
        process_line_step.name,
      ]"
    ></bread-crumbs>

    <div class="flex flex-row justify-end">
      <new-button
        @click.prevent="goToNewProcessLineExecStep"
        :label="$t('labels.new_process_line_exec_step_button')"
      />
    </div>

    <div v-if="load_data" class="mt-4">
      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-alpine w-full h-full"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="process_line_exec_steps"
      >
      </ag-grid-vue>
    </div>

    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/exec_steps/show_step.js";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import GoToLink from "@/components/views/layout/ag_grid/GoToLink.vue";

export default {
  name: "PHProcessExecStepsShowStep",
  components: {
    AgGridVue,
  },
  data() {
    return {
      packing_house_process: {},
      process_line_step: {},
      process_line_exec_steps: [],
      load_data: false,
      defaultColDef: {
        sortable: true,
        filter: true,
      },
      columnDefs: [
        {
          headerName: this.$t("model.process_line_exec_step.executed_at"),
          field: "executed_at",
          flex: 1,
          minWidth: 200,
          cellRenderer: (params) => this.dateFormatter(params.value),
        },
        {
          headerName: this.$t("model.process_line_exec_step.process_line"),
          field: "process_line.name",
          flex: 1,
        },
        {
          headerName: this.$t(
            "model.process_line_exec_step.process_line_exec_inputs"
          ),
          field: "process_line_exec_inputs",
          cellRenderer: (params) => {
            return params.value
              .map(
                (input) =>
                  `${input.process_line_product.name}: ${input.value} ${input.unit}`
              )
              .join(", ");
          },
          flex: 1,
        },
        {
          headerName: this.$t(
            "model.process_line_exec_step.process_line_exec_outputs"
          ),
          field: "process_line_exec_outputs",
          cellRenderer: (params) => {
            return params.value
              .map(
                (input) =>
                  `${input.process_line_product.name}: ${input.value} ${input.unit}`
              )
              .join(", ");
          },
          flex: 1,
        },
        {
          headerName: "",
          field: "id",
          filter: true,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: this.$t("labels.manage_link"),
                path_name: this.routeName("show_exec_step"),
                params_path: {
                  packing_house_id: this.packing_house_id,
                  packing_house_process_id: this.packing_house_process_id,
                  process_line_step_id: this.process_line_step_id,
                  id: params.value,
                },
              },
            };
          },
        },
      ],
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    process_line_step_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() => {
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fetchPackingHouseProcess();
        this.fetchProcessLineStep();
        this.fetchProcessLineExecSteps();
      });
    });
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },

    fetchProcessLineStep: async function () {
      let response = await Requester.fetchProcessLineStep(
        this.packing_house_id,
        this.process_line_step_id
      );
      this.process_line_step = response.data;
    },

    fetchProcessLineExecSteps: async function () {
      let response = await Requester.fetchProcessLineExecSteps(
        this.packing_house_id,
        this.process_line_step_id
      );
      this.process_line_exec_steps = response.data;
      this.load_data = true;
    },

    goToNewProcessLineExecStep: function () {
      this.$router.push({
        name: this.routeName("new_exec_step"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          process_line_step_id: this.process_line_step_id,
        },
      });
    },

    goToShowExecStep: function (process_line_step_id) {
      this.$router.push({
        name: this.routeName("show_step"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          process_line_step_id: process_line_step_id,
        },
      });
    },
  },
};
</script>
